import { TEMPLATE_FORM_CONSTANTS } from '../constants';

export const insertEmailButton = (quillRef: any, content: string): string => {
  const quill = quillRef?.current?.getEditor?.();
  if (!quill) return content;

  const range = quill.getSelection();
  if (range) {
    const buttonHtml = `
<div style="text-align: center; margin: 20px 0;">
    <a href="#" style="
        display: inline-block;
        padding: 12px 24px;
        background-color: #007bff;
        color: #ffffff;
        text-decoration: none;
        border-radius: 4px;
        font-weight: bold;
        font-size: 16px;
        border: none;
        cursor: pointer;
    ">Click Here</a>
</div>`;
    quill.clipboard.dangerouslyPasteHTML(range.index, buttonHtml);
    return content;
  }
  return content;
};

export const insertEmailDivider = (quillRef: any, content: string): string => {
  const quill = quillRef?.current?.getEditor?.();
  if (!quill) return content;

  const range = quill.getSelection();
  if (range) {
    const dividerHtml = `
<div style="margin: 20px 0; text-align: center;">
    <hr style="border: none; border-top: 2px solid #e0e0e0; width: 100%; margin: 0;">
</div>`;
    quill.clipboard.dangerouslyPasteHTML(range.index, dividerHtml);
    return content;
  }
  return content;
};

export const insertEmailSpacer = (quillRef: any, content: string): string => {
  const quill = quillRef?.current?.getEditor?.();
  if (!quill) return content;

  const range = quill.getSelection();
  if (range) {
    const spacerHtml = `<div style="height: 30px; line-height: 30px;">&nbsp;</div>`;
    quill.clipboard.dangerouslyPasteHTML(range.index, spacerHtml);
    return content;
  }
  return content;
};

export const insertSocialLinks = (quillRef: any, content: string): string => {
  const quill = quillRef?.current?.getEditor?.();
  if (!quill) return content;

  const range = quill.getSelection();
  if (range) {
    const socialHtml = `
<div style="text-align: center; margin: 20px 0;">
    <a href="#" style="display: inline-block; margin: 0 10px; text-decoration: none;">
        <img src="https://via.placeholder.com/32x32/3b5998/ffffff?text=f" alt="Facebook" style="width: 32px; height: 32px; border-radius: 4px;">
    </a>
    <a href="#" style="display: inline-block; margin: 0 10px; text-decoration: none;">
        <img src="https://via.placeholder.com/32x32/1da1f2/ffffff?text=t" alt="Twitter" style="width: 32px; height: 32px; border-radius: 4px;">
    </a>
    <a href="#" style="display: inline-block; margin: 0 10px; text-decoration: none;">
        <img src="https://via.placeholder.com/32x32/0077b5/ffffff?text=in" alt="LinkedIn" style="width: 32px; height: 32px; border-radius: 4px;">
    </a>
    <a href="#" style="display: inline-block; margin: 0 10px; text-decoration: none;">
        <img src="https://via.placeholder.com/32x32/e4405f/ffffff?text=ig" alt="Instagram" style="width: 32px; height: 32px; border-radius: 4px;">
    </a>
</div>`;
    quill.clipboard.dangerouslyPasteHTML(range.index, socialHtml);
    return content;
  }
  return content;
};

export const getPrebuiltTemplate = (type: string): string => {
  switch (type) {
    case TEMPLATE_FORM_CONSTANTS.TEMPLATES.HEADER:
      return `
<div style="background-color: #f8f9fa; padding: 20px; text-align: center; border-bottom: 3px solid #007bff;">
    <img src="https://via.placeholder.com/200x60/007bff/ffffff?text=Logo" alt="Company Logo" style="max-width: 200px; height: auto;">
    <h1 style="margin: 10px 0 0 0; color: #333; font-size: 24px; font-weight: bold;">Company Name</h1>
</div>`;
    case TEMPLATE_FORM_CONSTANTS.TEMPLATES.FOOTER:
      return `
<div style="background-color: #343a40; color: #ffffff; padding: 30px; text-align: center; margin-top: 40px;">
    <p style="margin: 0 0 10px 0; font-size: 14px;">© 2025 Company Name. All rights reserved.</p>
    <p style="margin: 0 0 15px 0; font-size: 12px; color: #adb5bd;">
        123 Business St, Suite 100<br>
        City, State 12345<br>
        Phone: (555) 123-4567
    </p>
    <div style="margin: 15px 0;">
        <a href="#" style="color: #17a2b8; text-decoration: none; margin: 0 10px; font-size: 12px;">Unsubscribe</a>
        <a href="#" style="color: #17a2b8; text-decoration: none; margin: 0 10px; font-size: 12px;">Privacy Policy</a>
        <a href="#" style="color: #17a2b8; text-decoration: none; margin: 0 10px; font-size: 12px;">Contact Us</a>
    </div>
</div>`;
    case TEMPLATE_FORM_CONSTANTS.TEMPLATES.TWO_COLUMN:
      return `
<div style="display: table; width: 100%; margin: 20px 0;">
    <div style="display: table-cell; width: 50%; padding: 0 10px; vertical-align: top;">
        <h3 style="color: #333; margin: 0 0 15px 0;">Column 1 Title</h3>
        <p style="margin: 0; line-height: 1.6; color: #666;">Add your content here. This is the left column of your two-column layout.</p>
    </div>
    <div style="display: table-cell; width: 50%; padding: 0 10px; vertical-align: top;">
        <h3 style="color: #333; margin: 0 0 15px 0;">Column 2 Title</h3>
        <p style="margin: 0; line-height: 1.6; color: #666;">Add your content here. This is the right column of your two-column layout.</p>
    </div>
</div>`;
    case TEMPLATE_FORM_CONSTANTS.TEMPLATES.IMAGE_TEXT:
      return `
<div style="display: table; width: 100%; margin: 20px 0;">
    <div style="display: table-cell; width: 200px; padding: 0 20px 0 0; vertical-align: top;">
        <img src="https://via.placeholder.com/180x120/007bff/ffffff?text=Image" alt="Featured Image" style="width: 100%; height: auto; border-radius: 8px;">
    </div>
    <div style="display: table-cell; vertical-align: top; padding: 0;">
        <h3 style="color: #333; margin: 0 0 15px 0;">Featured Content</h3>
        <p style="margin: 0 0 15px 0; line-height: 1.6; color: #666;">Add your description here. This layout combines an image with accompanying text content.</p>
        <a href="#" style="display: inline-block; padding: 8px 16px; background-color: #007bff; color: #ffffff; text-decoration: none; border-radius: 4px; font-size: 14px;">Learn More</a>
    </div>
</div>`;
    default:
      return '';
  }
};

export const formatHtmlCode = (htmlContent: string): string => {
  try {
    let formatted = htmlContent.replace(/></g, '>\n<').replace(/^\s+|\s+$/g, '');

    const lines = formatted.split('\n');
    let indent = 0;
    const indentSize = 4;

    const formattedLines = lines.map((line) => {
      const trimmed = line.trim();
      if (trimmed.startsWith('</')) {
        indent = Math.max(0, indent - indentSize);
      }
      const result = ' '.repeat(indent) + trimmed;
      if (trimmed.startsWith('<') && !trimmed.startsWith('</') && !trimmed.endsWith('/>')) {
        indent += indentSize;
      }
      return result;
    });

    return formattedLines.join('\n');
  } catch (error) {
    console.error('Error formatting HTML:', error);
    return htmlContent;
  }
};

export const processPreviewContent = (content: string, variables: string[]): string => {
  let processedContent = content;
  variables.forEach((variable) => {
    const variableName = variable.replace(/[{}]/g, '');
    const sampleValue = getSampleValueForVariable(variableName);
    processedContent = processedContent.replace(
      new RegExp(variable.replace(/[{}]/g, '\\{\\}'), 'g'),
      sampleValue
    );
  });
  return processedContent;
};

export const getSampleValueForVariable = (variableName: string): string => {
  const sampleData: Record<string, string> = {
    first_name: 'John',
    last_name: 'Doe',
    user_name: 'John Doe',
    email: 'john.doe@example.com',
    company: 'Acme Corp',
    date: new Date().toLocaleDateString(),
    time: new Date().toLocaleTimeString(),
    action_url: 'https://example.com',
    login_url: 'https://example.com/login',
    newsletter_url: 'https://example.com/newsletter',
    offer_url: 'https://example.com/offer',
    transaction_id: 'TXN12345678',
    amount: '$99.99',
  };
  return sampleData[variableName] || `[${variableName}]`;
};

export const getResponsiveModules = (): Record<string, any> => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  const baseModules = {
    clipboard: {
      matchVisual: false,
    },
    history: {
      delay: 1000,
      maxStack: 50,
      userOnly: true,
    },
  };

  if (isMobile) {
    return {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ color: [] }],
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image'],
        ['clean'],
      ],
      ...baseModules,
    };
  }

  return {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      ['blockquote', 'code-block'],
      ['link', 'image'],
      [{ script: 'sub' }, { script: 'super' }],
      ['clean'],
    ],
    ...baseModules,
  };
};

export const insertVariableInEditor = (
  editorMode: string,
  variable: string,
  quillRef: any,
  htmlContent: string,
  onFormChange: (field: string, value: any) => void
): void => {
  if (editorMode === 'visual' && quillRef?.current) {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();
    const index = range ? range.index : quill.getLength();
    quill.insertText(index, variable);
    quill.setSelection(index + variable.length);
  } else {
    const textarea = document.getElementById('htmlContentCode') as HTMLTextAreaElement;
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = htmlContent;
      const before = text.substring(0, start);
      const after = text.substring(end, text.length);
      const newText = before + variable + after;

      onFormChange('htmlContent', newText);

      setTimeout(() => {
        textarea.setSelectionRange(start + variable.length, start + variable.length);
        textarea.focus();
      }, 0);
    }
  }
};

export const resetFormData = () => ({
  name: '',
  type: '',
  subject: '',
  htmlContent: '',
  textContent: '',
  status: TEMPLATE_FORM_CONSTANTS.DEFAULT_VALUES.STATUS,
  isDefault: false,
  description: '',
  fromEmail: TEMPLATE_FORM_CONSTANTS.DEFAULT_VALUES.FROM_EMAIL,
  fromName: TEMPLATE_FORM_CONSTANTS.DEFAULT_VALUES.FROM_NAME,
  replyTo: '',
  attachments: [],
});

export const isValidEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
